export function isLineOrArrowTool(tool: string | undefined): tool is 'line' | 'arrow' {
  return tool === 'line' || tool === 'arrow';
}
